<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .trial-ending-banner {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
    min-width: 0;
    gap: utils.in_rem(8px);
    font-size: 16px;
  }

  .content {
    flex: 1; // This will make content take all available space
    a {
      @include colors.color(primary_50);
    }
  }

  .ctas {
    display: flex;
    flex-direction: row;
    gap: utils.in_rem(12px);
    justify-content: flex-end;
    margin-left: auto;
  }
</style>

<script>
  let { onUpgrade } = $props();
  import Button from "@sourcewhale/shared/svelte-design-system/components/atoms/Button.svelte";
  import { userStore } from "@sourcewhale/shared/src/svelte/api-stores/user-store";
  import UpgradeTrialButton from "../../../components/trials/UpgradeTrialButton.svelte";
  let nDays = $derived($userStore.plgTrialDaysRemaining || 0);
</script>

<div class="trial-ending-banner">
  <div class="content">
    You have <b>{nDays === 1 ? "1 day" : `${nDays} days`}</b>
    left in your free trial of Notetaker and Inbox Agent. Need help onboarding or
    would like to find out more? Read
    <a
      href="https://help.sourcewhale.app/en/articles/11874279-notetaker-inbox-agent-trial"
      target="_blank"
      rel="noopener noreferrer">Help Guides</a
    >
  </div>

  <div class="ctas">
    <Button
      kind="tertiary"
      size="large"
      onclick={() => {
        window.open("https://sourcewhale.navattic.com/yh3a059c");
      }}>Take a tour</Button
    >
    <UpgradeTrialButton
      onclick={onUpgrade}
      size="large"
      text="Get Full Access"
    />
  </div>
</div>
